import { Pagination as MantinePagination, createStyles } from '@mantine/core';

import { isDark } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';

const usePaginationStyle = createStyles((theme) => ({
  container: {
    padding: '40px 10px',
    justifyContent: 'right',
    [theme.fn.smallerThan('xs')]: {
      padding: '40px 0px',
      justifyContent: 'center',
    },
  },
}));

const Pagination = ({ totalNum, itemPerPage, pageNum, onChange }) => {
  const { dark } = isDark();
  const { classes } = usePaginationStyle();

  return (
    <MantinePagination
      total={Math.ceil(Number(totalNum) / Number(itemPerPage))}
      value={Number(pageNum)}
      onChange={onChange}
      className={classes.container}
      boundaries={0}
      siblings={2}
      styles={() => ({
        dots: { display: 'none' },
        control: {
          borderColor: themeVariables.colors.light200,
          color: themeVariables.darkMode.strong(dark),
        },
      })}
    />
  );
};

export default Pagination;
